<template>
  <div class="home" >
    <div class="background">
    <img :src="require('../static/images/homepage-bg.png')"  class="homeBG"/>
    </div>
    
    <div class="content">
    <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" >
        <el-menu-item index="1" style="color:white; opacity:0.8; font-size:20px "><router-link to="/">首页</router-link></el-menu-item>
    </el-menu>
    <p class="t1">苏医在线</p>
    <p class="t2">您的远程问诊专家</p>
    <p class="t3">在线问诊&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;电子处方</p>
    <p class="t4">·&nbsp;患者在线咨询，医生快速答复</p>
    <p class="t5">·&nbsp;药店申请电子处方，医生在线审核</p>
    <p class="t5">·&nbsp;打通患者、医生、药店信息壁垒</p>
    </div>
    <div class="icp"> 
    <p class="contacttext">联系人：吴经理&nbsp;&nbsp;邮箱：njsuhansoft@163.com</p>
    <a class="icptext" href="http://beian.miit.gov.cn">苏ICP备2020056389号</a>
    </div>


  </div>
</template>

<script>
export default {
  name: 'Home',
  data() {
      return {
        activeIndex: '1',
      }
    },
  props: {
    msg: String,
  },
  
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.homeBG{
  width:100%;
  height: 100%;
  z-index:-1;
  position: absolute;

  margin-top: -60px;
  margin-left: -100px;

}
.el-menu-demo{
  background-color:transparent;
  border-bottom-color:transparent;
  
}

.content{
  height:500px;
}
.t1{
  font-family:'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
  font-size: 40px;
  color: white;
  padding-top:30px;
}

.t2{
  font-family:'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
  font-size: 35px;
  color: white;
  margin-top: -35px;
}


.t3{
  font-family:'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
  font-size: 25px;
  font:bold;
  color: white;
  margin-top: -5px;
  margin-left:10px;
}


.t4{
  font-family:'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
  font-size: 20px;
  color: white;
  margin-top: 20px;
}

.t5{
  font-family:'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
  font-size: 20px;
  color: white;
  margin-top: -15px;
}

.icp{
  text-align: center; 
  width:80%;
  height:40px;
  position: absolute;
  top:85%;
  
}

.icptext{
  font-family:'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
  font-size: 15px;
  color: white;
}


.contacttext{
  font-family:'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
  font-size: 15px;
  color: white;
}
</style>
